/* eslint camelcase: 0 */
import { Admission, AdmissionRequest, CheckInRequest, CheckOutRequest } from '@/infrastructure/network/Monitaro/schema/models'
import { IAdmissionProps, EmptyAdmissionPropsFactory } from '@/entities/Admission'

export const toAdmissionProps = (props: Admission | null | undefined): IAdmissionProps => {
  if (!props) {
    return EmptyAdmissionPropsFactory()
  }

  const { id, hospital_id, user_id, area_id, user, hospital, area, staytime, properties, checkin_at, checkout_at, created_at, updated_at } = props

  return EmptyAdmissionPropsFactory({
    id,
    hospitalId: hospital_id,
    userId: user_id,
    areaId: area_id,
    user,
    hospital,
    area,
    staytime,
    properties,
    checkinAt: checkin_at,
    checkoutAt: checkout_at,
    createdAt: created_at,
    updatedAt: updated_at
  })
}

export const toAdmissionRequest = (props: IAdmissionProps): AdmissionRequest => {
  const { properties } = props
  return {
    properties: properties!
  }
}

export const toCheckInRequest = (props: IAdmissionProps): CheckInRequest => {
  const { checkinAt, properties } = props
  return {
    checkin_at: checkinAt!,
    properties: properties!
  }
}

export const toCheckOutRequest = (props: IAdmissionProps): CheckOutRequest => {
  const { checkoutAt } = props
  return {
    checkout_at: checkoutAt!
  }
}
